<template>
  <v-card flat>
    <v-card-title>
      <v-btn
        color="indigo"
        dark
        x-small
        fab
        absolute
        top
        right
        @click="old = !old"
      >
        <v-icon v-if="old">mdi-timer</v-icon>
        <v-icon v-if="!old">mdi-av-timer</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="mt-4" v-if="old">
      <v-data-table
        :headers="ligneHeaders"
        :items="tabItem"
        item-key="id"
        @dblclick:row="openTab"
      >
      </v-data-table>
    </v-card-text>
    <v-card-text v-if="!old">
      <v-container>
        <v-card
          flat
          color="blue-grey lighten-5"
          v-for="(robs, j) in groupItems"
          class="ma-3"
          :key="j"
        >
          <v-card-title class="display-3 mb-4 indigo--text">
            {{ j }}
          </v-card-title>
          <v-card-text>
            <v-row v-if="robs">
              <template v-for="(rob, i) in robs">
                <v-col
                  v-if="rob.statut === 'ENCOURS'"
                  cols="4"
                  :key="i"
                  :class="rob.lignesRob.total === 0 ? 'd-none' : ''"
                >
                  <v-card
                    elevation="4"
                    class="mb-2 radia"
                    @dblclick="open(rob)"
                  >
                    <my-card-title
                      :color="color(rob)"
                      :sous-titre="!rob.date ? 'Mois en cours' : rob.date"
                      :titre="rob.centre_facturation"
                    />
                    <v-card-text>
                      <my-progress-bar :item="rob" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { robMixin } from "@/mixins/rob";
import { structureMixin } from "@/mixins/structure";
import { generalMixin } from "@/mixins/general";
import { cardMixin } from "@/mixins/cardMixin";
import { tvaMixin } from "@/mixins/tva";

export default {
  name: "VueShowRobDr",
  mixins: [robMixin, structureMixin, generalMixin, cardMixin, tvaMixin],
  data() {
    return { old: false };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ligneHeaders() {
      return [
        {
          text: this.$t("rob.description.dr"),
          align: "start",
          sortable: true,
          value: "dr",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("carte.centre_facturation"),
          align: "start",
          sortable: true,
          value: "centre_facturation",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("rob.description.date"),
          align: "start",
          sortable: true,
          value: "date",
          class: "color_thead  lighten-2 white--text",
        },
      ];
    },
    tabItem() {
      const a = Object.values(this.groupItems).map((values) =>
        values.map(function (x) {
          if (x.statut !== "ENCOURS")
            return {
              dr: x.dr,
              id: x.id,
              centre_facturation: x.centre_facturation,
              date: x.date,
            };
        })
      );
      return a.flat().filter((x) => x !== undefined);
    },
    groupItems() {
      const groupBy = (key) => (array) =>
        array.reduce((objectsByKeyValue, obj) => {
          const value = obj[key];
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(
            obj
          );
          return objectsByKeyValue;
        }, {});
      const groupByBrand = groupBy("dr");
      return groupByBrand(this.items);
    },
  },
  methods: {
    open(rob) {
      this.affichage.rob = "tab-2";
      this.paramsRob.robId = rob.id;
      this.breadCrumbs.rob = rob.centre_facturation;
      this.breadCrumbs.structure = null;
      this.breadCrumbs.carte = null;
      this.getStructures(this.paramsRob.robId);
    },
    openTab(event, { item }) {
      this.open(item);
    },
  },
};
</script>

<style scoped>
.v-card__text {
  width: 100%;
  top: -10px;
  position: relative;
}
</style>
